import React, { ChangeEvent } from 'react';
import {
  AuthWrapper,
  AuthContainer,
  LoginButton,
  FormSection,
  LoginInputWithIcon,
  ImageContainer,
  SideImage,
  FormHeader,
  FormBox,
  Logo,
  FormWrapper,
  LogoContainer,
  LoginInput,
  ResetPasswordContainer,
  RememberMeInput,
  ResetPasswordLink,
  CheckboxLabel,
  RememberMeContainer
} from './styles';
import sojiLogo from '../../assets/soji_logo.svg';
import sideImage from '../../assets/login_image.svg';
import viewPassword from '../../assets/viewPassword.svg';
import { useUserLoginMutation } from '../../store/auth/api';
import { useFormik } from 'formik';
import { loginValidation } from './validation';
import { showErrorToast, showSuccessToast } from '../../utils/toast';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setRemeberUser, setUser } from '../../store/auth';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [userLogin, { isLoading }] = useUserLoginMutation();
  const auth = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const handleLogin = (values: { email: string; password: string }) => {
    userLogin(values)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        if (result.data.role !== 'admin') {
          return showErrorToast('Unathourized');
        }
        dispatch(setUser(result.data));
        navigate('/', { replace: true });
      })
      .catch((err) => {
        showErrorToast(err.message);
      });
  };
  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: loginValidation,
    onSubmit: handleLogin
  });
  const handleRemeberMe = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setRemeberUser(e.target.checked));
  };
  return (
    <>
      <AuthWrapper>
        <AuthContainer>
          <FormSection>
            <FormWrapper>
              <LogoContainer>
                <Logo src={sojiLogo} />
              </LogoContainer>
              <FormHeader>Login</FormHeader>
              <FormBox onSubmit={handleSubmit}>
                <LoginInput
                  labelText={'Email address'}
                  type={'email'}
                  value={values.email}
                  onChange={handleChange('email')}
                  errorMessage={touched.email ? errors.email : ''}
                  placeholder={'Enter Email address'}
                />
                <LoginInputWithIcon
                  labelText={'Password'}
                  value={values.password}
                  onChange={handleChange('password')}
                  errorMessage={touched.password ? errors.password : ''}
                  placeholder={'Password'}
                  type={'password'}
                  icon={viewPassword}
                />
                <ResetPasswordContainer>
                  <RememberMeContainer>
                    <RememberMeInput
                      type="checkbox"
                      defaultChecked={auth.rememberUser}
                      // checked={rememberUser}
                      onChange={handleRemeberMe}
                    />
                    <CheckboxLabel>Remember me</CheckboxLabel>
                  </RememberMeContainer>
                  <ResetPasswordLink to={'/password-reset'}>
                    Reset Password?
                  </ResetPasswordLink>
                </ResetPasswordContainer>
                <LoginButton
                  disabled={isLoading}
                  buttonText={'Login'}
                  isLoading={isLoading}
                  type={'submit'}
                />
              </FormBox>
            </FormWrapper>
          </FormSection>
          <ImageContainer>
            <SideImage src={sideImage} />
          </ImageContainer>
        </AuthContainer>
      </AuthWrapper>
    </>
  );
};
export default Login;
